module.exports = __webpack_public_path__ + "static/media/timer.05b3439d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/timer.svg
// module id = 409
// module chunks = 103